module.exports = __webpack_public_path__ + "790d63a3df85a0bcdbd1c21b4e07a48e.png";